import React from 'react';

interface EndSessionConfigProps {
  config: any;
  onChange: (key: string, value: any) => void;
}

export const EndSessionConfig: React.FC<EndSessionConfigProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 dark:bg-blue-500/10 border border-blue-200 dark:border-blue-500/30 rounded-lg p-3 text-xs text-blue-700 dark:text-blue-200 leading-relaxed">
        <strong className="text-blue-800 dark:text-blue-100">Como funciona:</strong> Encerra a sessão do chatbot com o usuário. Opcionalmente envia uma mensagem de despedida. Após o encerramento, se o usuário enviar uma nova mensagem, uma nova sessão será iniciada do início do fluxo.
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1">
          Mensagem de Encerramento
        </label>
        <textarea
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          rows={2}
          placeholder="Atendimento encerrado. Obrigado!"
          value={config.message || ''}
          onChange={(e) => onChange('message', e.target.value)}
        />
      </div>
    </div>
  );
};
